import { KeyValue } from "@angular/common";
import { ContactTypeEnum } from "../models/ContactTypeEnum";

export enum ServiceChannel {
    Phone = 1,
    Email = 2
}

export const ServiceChannels: KeyValue<string, number>[] = [
    {key: 'Phone', value: 1}, {key: 'Email', value: 2 }
];

export enum ProductType {
  IDP = 1,
  Legal = 2
}

export enum TicketType {
  Referral = 1,
  PlanUsageQuestions = 2,
  MemberPortalAccountSetup = 3,
  MissingMemberMaterials = 4,
  LawFirmQuestion = 5,
  LawFirmTransferRequest = 6,
  BillingQuestion = 7,
  MemberNote = 10, // Legal
  IDPQuestion = 11,
  MissingEnrollmentInformation = 12,
  IDPComplaint = 13,
  MemberNote_IDP = 14, // IDP
  FinancialPlanning = 15,
  Caregiving = 16,
  PreSale = 17,
  UnableToLocate = 18
}

export const ProductTypeTicketMap: Record<ProductType, TicketType[]> = {
  [ProductType.Legal]: [
    TicketType.Referral,
    TicketType.PlanUsageQuestions,
    TicketType.MemberPortalAccountSetup,
    TicketType.MissingMemberMaterials,
    TicketType.LawFirmQuestion,
    TicketType.LawFirmTransferRequest,
    TicketType.BillingQuestion,
    TicketType.MemberNote,
    TicketType.FinancialPlanning,
    TicketType.Caregiving,
    TicketType.PreSale,
    TicketType.UnableToLocate
  ],
  [ProductType.IDP]: [
    TicketType.IDPQuestion,
    TicketType.MissingEnrollmentInformation,
    TicketType.IDPComplaint,
    TicketType.MemberNote_IDP
  ]
};

export enum EmailTemplateName {
    DigitalCardLocal = 'DigitalCard-LOCAL',
    DigitalCardNational = 'DigitalCard-NATIONAL'
}

export enum FirmCode {
  NationalFirm = '0200',
  NonPlanAttorney = '8088'
}

export const FirmType = {
  NAC: 'NAC',
  PAN: 'PAN',
  RAD: 'RAD',
  National: 'NATIONAL',
  Prospect: 'PROSPECT'
} as const;

// FirmDetail.STATUS values (dbo.DropDownValue, FirmDetail.Status); stored case varies, e.g. "Inactive".
export const FirmStatus = {
  Active: 'ACTIVE',
  Inactive: 'INACTIVE',
  Hold: 'HOLD',
  Probation: 'PROBATION'
} as const;

// Names from the Attorney Portal requirements; FirmDetail only stores the code.
export const FirmTypeNames: { [firmType: string]: string } = {
  [FirmType.PAN]: 'Core Firm',
  [FirmType.NAC]: 'National Firm',
  [FirmType.RAD]: 'Referral Firm'
};

export const SuggestedFirmTypes = [FirmType.NAC, FirmType.PAN, FirmType.RAD] as const;

export enum ReferralReasonId {
  NationalMember = 1
}

export const DefaultSuggestedFirmTypes: { [reasonId: number]: string[] } = {
  [ReferralReasonId.NationalMember]: [FirmType.NAC]
};

export const DefaultDeductionAmount = 150;

export const ContactTypeMap: { [key: number]: string } = {
  [ContactTypeEnum.Member]: 'Member',
  [ContactTypeEnum.Dependent]: 'Dependent',
  [ContactTypeEnum.Client]: 'Client',
  [ContactTypeEnum.MasterClient]: 'MasterClient',
  [ContactTypeEnum.LawFirm]: 'LawFirm',
  [ContactTypeEnum.HR]: 'HR',
  [ContactTypeEnum.AccountManager]: 'AccountManager',
  [ContactTypeEnum.PotencialMember]: 'PotencialMember'
};